import './CarouselButton.css';

const CarouselButton = ({children, rightSide, onClick}) => {
	let classList = "carouselButton";
	if (rightSide === true) {
		classList += " right";
	} else {
		classList += " left";
	}
	
	return (
		<button className={classList} onClick={onClick}>
			{children}
		</button>
	);
}

export default CarouselButton;